import { AnalyticsTypes } from '../../../../middleware/google-analytics';
import { BOOKING_SECTION_KEY } from '../BookingSection/constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../../EventTrackingConstants';

export const ActionTypes = {
    TRACK_TIMESGRID_CLICK_TIME: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_TIME`,
    TRACK_TIMESGRID_CLICK_NEXT: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_NEXT`,
    TRACK_TIMESGRID_CLICK_PREV: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_PREV`,
    TRACK_TIMESGRID_CLICK_MORE: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_MORE`,
    TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE`,
    TRACK_TIMESGRID_DATA_LOADED: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_DATA_LOADED`,
    TRACK_TIMESGRID_LOADED: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_LOADED`,
    TRACK_PROVIDER_AVAILABILITY_TOOLTIP: `${BOOKING_SECTION_KEY}/TRACK_PROVIDER_AVAILABILITY_TOOLTIP`,
    TRACK_PROVIDER_AVAILABILITY_CLICK_SEARCH: `${BOOKING_SECTION_KEY}/TRACK_PROVIDER_AVAILABILITY_CLICK_SEARCH`,
};

export const trackTimesgridDataLoaded = data => {
    const {
        availability,
    } = data;
    // Fix small typo issue
    let label = availability;
    if (label && label.substr(label.length - 1) === ';') {
        label = label.slice(0, -1);
    }
    return {
        type: ActionTypes.TRACK_TIMESGRID_DATA_LOADED,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Timesgrid Loaded Data',
                label,
                data: {
                    Component: TARGETS.TIMESGRID,
                    Element: TARGETS.TIMESGRID,
                    Initiator: EVENT_INITIATORS.SYSTEM,
                    InteractionType: INTERACTION_TYPES.UPDATE,
                    Section: TARGETS.BOOK_AN_APPOINTMENT,
                },
            },
        },
    };
};

export const trackProviderAvailabilityTooltipRendered = data => {
    const {
        availability,
    } = data;

    let label = availability;
    if (label && label.substr(label.length - 1) === ';') {
        label = label.slice(0, -1);
    }

    return {
        type: ActionTypes.TRACK_PROVIDER_AVAILABILITY_TOOLTIP,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Provider Availability Tooltip - Rendered',
                label,
                data: {
                    Component: TARGETS.PROVIDER_AVAILABILITY_TOOLTIP,
                    Element: TARGETS.PROVIDER_AVAILABILITY_TOOLTIP,
                    Initiator: EVENT_INITIATORS.SYSTEM,
                    InteractionType: INTERACTION_TYPES.VIEW,
                    Section: TARGETS.TIMESGRID_NO_AVAILABILITY,
                },
            },
        },
    };
};

export const trackProviderAvailabilityClickedSearch = specialtyId => {
    const label = specialtyId;

    return {
        type: ActionTypes.TRACK_PROVIDER_AVAILABILITY_CLICK_SEARCH,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Provider Availability Tooltip - Clicked Search Button',
                label,
                data: {
                    Component: TARGETS.PROVIDER_AVAILABILITY_TOOLTIP,
                    Element: TARGETS.PROVIDER_AVAILABILITY_TOOLTIP,
                    Initiator: EVENT_INITIATORS.SYSTEM,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Section: TARGETS.SEARCH_BUTTON,
                },
            },
        },
    };
};

export const trackProviderAvailabilityClickedClose = () => {
    return {
        type: ActionTypes.TRACK_PROVIDER_AVAILABILITY_CLICK_SEARCH,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Provider Availability Tooltip - Clicked Close',
                label: undefined,
                data: {
                    Component: TARGETS.PROVIDER_AVAILABILITY_TOOLTIP,
                    Element: TARGETS.PROVIDER_AVAILABILITY_TOOLTIP,
                    Initiator: EVENT_INITIATORS.SYSTEM,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Section: TARGETS.SEARCH_BUTTON,
                },
            },
        },
    };
};
